import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Image, Header, Icon} from 'semantic-ui-react';

const icon = require('../img/icons/404.svg');

class Error404 extends Component {

  render() {
    return (
      <div>
        <Helmet>
          <title>Página No Encontrada - Quipuu</title>
        </Helmet>
        <br/>
        <Header as='h1' icon textAlign='center'>
          <Icon><Image centered src={icon} height={400} alt='logo'/></Icon>
        </Header>
      </div>
    );
  }
}

export default Error404;



// WEBPACK FOOTER //
// ./src/containers/Error404.js